import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Guy from '@assets/images/ImageConditionCoche.svg';
import Dot from '@assets/images/Ellipse.png';

export const Condition: React.FC = () => {
  let letter = {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '19.5px',
  };

  const { breakpoints } = useTheme();
  const isTablet = useMediaQuery(breakpoints.down('md'));
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const isDesk = useMediaQuery(breakpoints.up('lg'));

  return (
    <Container
      maxWidth={!isTablet ? 'xl' : !isMobile ? 'md' : 'sm'}
      sx={{
        height: !isTablet ? '600px' : !isMobile ? '732px' : '850px',
        display: 'flex',
        justifyContent:'center',
        alignItems: 'center',
      }}
    >
      <Grid
        container
        height={!isTablet ? '341px' : !isMobile ? '632px' : '758px'}
        sx={{
          width: isDesk ? '80%' : '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: isMobile || isTablet ? 'center' : 'space-between',
          flexWrap: isMobile || isTablet ? 'wrap' : 'nowrap',
        }}
      >
        <Box
          component={'img'}
          loading="lazy"
          src={Guy}
          sx={{
            width: !isTablet ? '440px' : !isMobile ? '440px' : '316px',
            height: !isTablet ? '341px' : !isMobile ? '341px' : '245px',
          }}
        ></Box>
        <Box
          sx={{
            width: !isTablet ? '655px' : !isMobile ? '688px' : '333px',
            height: !isTablet ? '274px' : !isMobile ? '267px' : '364px',
            alignSelf: 'center',
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: 700,
              fontSize: !isTablet ? '28px' : !isMobile ? '22px' : '20px',
              lineHeight: !isTablet ? '34px' : !isMobile ? '27px' : '24px',
            }}
          >
            ¿Puedo asegurar mi vehículo ?
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ display: 'flex', margin: '14px 0' }}>
              <Box
                component={'img'}
                loading="lazy"
                src={Dot}
                width={16}
                height={16}
                margin={'auto 24px auto 0'}
              ></Box>
              <Typography sx={letter}>
                Si es <b>Auto/Camioneta</b> debe tener <b>Menos</b> de 30 años
                de antigüedad.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', margin: '14px 0' }}>
              <Box
                component={'img'}
                loading="lazy"
                src={Dot}
                width={16}
                height={16}
                margin={'auto 24px auto 0'}
              ></Box>
              <Typography sx={letter}>
                Tiene que ser sólo de uso particular.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', margin: '14px 0' }}>
              <Box
                component={'img'}
                loading="lazy"
                src={Dot}
                width={16}
                height={16}
                margin={'auto 24px auto 0'}
              ></Box>
              <Typography sx={letter}>
                <b>No</b> puede ser un vehículo legalizado ni fronterizo.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', margin: '14px 0' }}>
              <Box
                component={'img'}
                loading="lazy"
                src={Dot}
                width={16}
                height={16}
                margin={'auto 24px auto 0'}
              ></Box>
              <Typography sx={letter}>
                <b>No</b> puede ser un vehículo cuya factura haya sido emitida
                por una aseguradora, es decir, "vehículo de salvamentos".
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', margin: '14px 0' }}>
              <Box
                component={'img'}
                loading="lazy"
                src={Dot}
                width={16}
                height={16}
                margin={'auto 24px auto 0'}
              ></Box>
              <Typography sx={letter}>
                <b>No</b> puede estar chocado cuando contrates tu seguro.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Container>
  );
};
